import PropTypes from 'prop-types'

/**
 * Shared PropType for the timeseries-latch config object passed through
 * `QBPPresentation` to every blueprint renderer + the picker. Keeps the
 * shape definition in one place so renderers can't drift on field
 * presence/required-ness.
 */
export const timeseriesLatchPropType = PropTypes.shape({
  periodParameter: PropTypes.string.isRequired,
  rangeParameter: PropTypes.string.isRequired,
  periodColumn: PropTypes.string.isRequired,
  dateColumn: PropTypes.string.isRequired,
  dateTable: PropTypes.string.isRequired,
  supportedPeriods: PropTypes.arrayOf(
    PropTypes.oneOf(['day', 'week', 'month', 'quarter', 'year'])
  ).isRequired,
  defaultPeriod: PropTypes.oneOf(['day', 'week', 'month', 'quarter', 'year']).isRequired,
  defaultBehavior: PropTypes.oneOf(['required', 'latest', 'trailing']),
  defaultRange: PropTypes.shape({
    kind: PropTypes.oneOf(['absolute', 'trailing', 'calendarYear']).isRequired,
    from: PropTypes.string,
    to: PropTypes.string,
    asOfDate: PropTypes.string,
    periods: PropTypes.number,
    excludeCurrentPeriod: PropTypes.bool,
    calendarYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  limit: PropTypes.number
})
